"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parkingLotsLayerId = void 0;
exports.useParkingLots = useParkingLots;
var _maplibreGl = require("maplibre-gl");
var _react = _interopRequireWildcard(require("react"));
var _client = require("react-dom/client");
var _reactI18next = require("react-i18next");
var _parkingPopup = _interopRequireDefault(require("../../components/map/parking-popup"));
var _models = require("../../models");
var _utils = require("../../utils");
var _layers = require("./layers");
var _popup = require("./popup");
var _routing = require("./routing");
var _source = require("./source");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const sourceId = 'parkingLots';
const parkingLotsLayerId = exports.parkingLotsLayerId = 'parkingLots';
const asMarkerMinZoom = 17;
function useParkingLots(map, theme, smallDevice = false, onSelect) {
  const [selectedParking, selectParking] = (0, _react.useState)(null);
  const hoveredParkingId = (0, _react.useRef)(null);
  const initialized = (0, _react.useRef)(false);
  const markers = (0, _react.useRef)({});
  const parkingTooltip = (0, _react.useRef)(null);
  const parkingLotsRef = (0, _react.useRef)([]);
  const selectedParkingIdRef = (0, _react.useRef)(null);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    getGeoJSONSource,
    addGeoJSONSource,
    updateGeoJSONSource,
    clearGeoJSONSource
  } = (0, _source.useSource)(map, sourceId);
  const {
    addCircleLayer
  } = (0, _layers.useLayers)(map);
  const {
    centerPopup
  } = (0, _popup.usePopup)(map);
  function init() {
    if (!map || initialized.current) return;
    if (getGeoJSONSource()) {
      initialized.current = true;
      return;
    }
    addGeoJSONSource();
    addCircleLayer(parkingLotsLayerId, sourceId, {
      'circle-radius': ['case', ['boolean', ['feature-state', 'hover'], false], 8, 4],
      'circle-stroke-width': 2,
      'circle-stroke-opacity': 1,
      'circle-color': ['get', 'color'],
      'circle-stroke-color': '#fff'
    });
    map.on('mouseenter', parkingLotsLayerId, event => {
      if (event.defaultPrevented) return;
      event.originalEvent.preventDefault();
      event.preventDefault();
      map.getCanvas().style.cursor = 'pointer';
      const {
        point,
        features
      } = event;
      if (map.queryRenderedFeatures(point).find(({
        layer: {
          id: layerId
        }
      }) => [_routing.arrivalLayerId, _routing.wayPointsLayerId].indexOf(layerId) !== -1) || !features || !features[0]) return;
      const {
        id,
        geometry,
        properties
      } = features[0];
      if (selectedParkingIdRef.current === id) return;
      if (typeof id === 'number' && geometry.type === 'Point') {
        const {
          coordinates: [lng, lat]
        } = geometry;
        openTooltip(id, {
          lat,
          lng
        }, {
          capacity: properties?.capacity || 0,
          sheltered: properties?.sheltered || false,
          supervised: properties?.supervised || false,
          locked: properties?.locked || false
        });
      }
    });
    map.on('mousemove', parkingLotsLayerId, event => {
      const {
        point,
        features
      } = event;
      if (map.queryRenderedFeatures(point).find(({
        layer: {
          id: layerId
        }
      }) => [_routing.wayPointsLayerId, _routing.arrivalLayerId].indexOf(layerId) !== -1) || !features || !features[0]) return;
      const {
        id
      } = features[0];
      if (hoveredParkingId.current) {
        map.removeFeatureState({
          source: sourceId,
          id: hoveredParkingId.current
        });
      }
      if (id) {
        hoveredParkingId.current = id;
        if (hoveredParkingId.current) {
          map.setFeatureState({
            source: sourceId,
            id: hoveredParkingId.current
          }, {
            hover: true
          });
        }
      }
    });
    map.on('mouseleave', parkingLotsLayerId, () => {
      map.getCanvas().style.cursor = '';
      clearTooltip();
      if (hoveredParkingId.current) {
        map.setFeatureState({
          source: sourceId,
          id: hoveredParkingId.current
        }, {
          hover: false
        });
      }
      hoveredParkingId.current = null;
    });
    map.on('click', parkingLotsLayerId, event => {
      if (event.originalEvent.defaultPrevented) return;
      event.originalEvent.preventDefault();
      const {
        features
      } = event;
      if (features && features.length > 0) {
        const {
          id: parkingId,
          geometry
        } = features[0];
        if (typeof parkingId === 'number') {
          selectedParkingIdRef.current = parkingId;
          selectParking(parkingLotsRef.current.find(({
            id
          }) => id === parkingId) || null);
        }
        if (geometry.type === 'Point') {
          const {
            coordinates: [lng, lat]
          } = geometry;
          map.flyTo({
            center: {
              lat,
              lng
            },
            zoom: asMarkerMinZoom
          });
        }
      }
    });
    initialized.current = true;
  }
  function openParkingPopup(parking) {
    if (smallDevice) return;
    const {
      location: {
        point: {
          coordinates: [lng, lat]
        }
      }
    } = parking;
    const selectedMarker = selectedParkingIdRef.current && markers.current[selectedParkingIdRef.current];
    if (!selectedMarker) {
      selectedParkingIdRef.current = null;
      selectParking(null);
      return;
    }
    if (selectedMarker.marker.getPopup().isOpen()) return;
    selectedMarker.marker.togglePopup();
    const ele = document.getElementById(`parking-${parking.id}-popup`);
    if (ele) {
      const container = (0, _client.createRoot)(ele);
      container.render(/*#__PURE__*/_react.default.createElement(_parkingPopup.default, {
        onClose: () => {
          if (selectedMarker.marker.getPopup().isOpen()) selectedMarker.marker.togglePopup();
          if (container) container.unmount();
        },
        onSelect: onSelect,
        parking: parking,
        theme: theme
      }));
    }
    centerPopup({
      lat,
      lng
    }, selectedMarker.marker.getPopup());
  }
  function closePrevSelectedParkingPopup() {
    Object.values(markers.current).forEach(({
      id,
      marker
    }) => {
      if (id !== selectedParkingIdRef.current && marker.getPopup().isOpen()) marker.togglePopup();
    });
  }
  function addMarker(parking) {
    if (!map) return;
    const {
      id,
      type,
      location: {
        point: {
          coordinates: [lng, lat]
        }
      },
      capacity,
      supervised,
      locked,
      free,
      network: networkKey
    } = parking;
    const network = networkKey && _models.parkingNetworks[networkKey] || null;
    const marker = (0, _utils.createImageMarker)({
      radius: 10,
      borderWidth: 2,
      backgroundImage: network ? network.icon : _models.parkingTypes[type].icon,
      backgroundColor: network ? network.color : supervised || !free ? '#7b7a9e' : '#6171FF',
      backgroundSize: !network && 18 || undefined
    }, {
      onClick: () => {
        clearTooltip();
        if (selectedParkingIdRef.current !== id) {
          selectedParkingIdRef.current = id;
          selectParking(parking);
          closePrevSelectedParkingPopup();
          openParkingPopup(parking);
        }
      },
      onMouseEnter: () => openTooltip(id, {
        lat,
        lng
      }, {
        capacity: capacity || 0,
        supervised: supervised || !free,
        sheltered: type === 'sheltered',
        locked
      }),
      onMouseLeave: () => clearTooltip()
    }).setLngLat({
      lat,
      lng
    }).setPopup(new _maplibreGl.Popup({
      maxWidth: '350px',
      closeButton: false,
      closeOnClick: true,
      className: 'map-custom-popup',
      offset: 6
    }).setHTML(`<div id="parking-${id}-popup"></div>`).on('close', () => {
      if (selectedParkingIdRef.current === id && markers.current[id]) {
        selectedParkingIdRef.current = null;
        selectParking(null);
      }
    })).addTo(map);
    markers.current[id] = {
      id,
      marker
    };
  }
  function update(parkingLots) {
    parkingLotsRef.current = parkingLots;
    if (!map) return;
    const zoom = map.getZoom();
    const parkingIds = zoom >= asMarkerMinZoom ? parkingLots.reduce((res, {
      id
    }) => {
      res[id] = true;
      return res;
    }, {}) : [];
    if (zoom >= asMarkerMinZoom) {
      // remove markers that are no longer visible
      Object.values(markers.current).filter(({
        id
      }) => !parkingLots.find(parking => parking.id === id)).forEach(({
        id,
        marker
      }) => {
        marker.remove();
        delete markers.current[id];
      });

      // unselect parking if no longer visible
      if (selectedParkingIdRef.current && !parkingIds[selectedParkingIdRef.current]) {
        selectedParkingIdRef.current = null;
        selectParking(null);
      }

      // add markers that were not visible
      parkingLots.filter(({
        id
      }) => !markers.current[id]).forEach(parking => addMarker(parking));

      // close previous selected parking popup
      closePrevSelectedParkingPopup();

      // open selected parking popup
      const _selectedParking = selectedParkingIdRef.current && parkingLots.find(({
        id
      }) => selectedParkingIdRef.current === id);
      if (_selectedParking) openParkingPopup(_selectedParking);
    } else {
      // remove markers
      Object.values(markers.current).forEach(({
        id,
        marker
      }) => {
        marker.remove();
        delete markers.current[id];
      });

      // unselect parking
      selectedParkingIdRef.current = null;
      selectParking(null);

      // add circle markers
      updateGeoJSONSource({
        type: 'FeatureCollection',
        features: parkingLots.map(({
          id,
          location: {
            point
          },
          capacity,
          type,
          supervised,
          locked,
          free,
          network: networkKey
        }) => ({
          id,
          type: 'Feature',
          geometry: point,
          properties: {
            capacity,
            supervised: supervised || !free,
            sheltered: type === 'sheltered',
            locked,
            color: networkKey ? _models.parkingNetworks[networkKey].color : supervised || !free ? '#7b7a9e' : '#6171FF'
          }
        }))
      });

      // close previous selected parking popup
      closePrevSelectedParkingPopup();
    }
  }
  function unselect() {
    selectedParkingIdRef.current = null;
    selectParking(null);
    closePrevSelectedParkingPopup();
  }
  function openTooltip(id, location, {
    capacity,
    supervised,
    sheltered,
    locked
  }) {
    parkingTooltip.current?.remove();
    if (!map || selectedParkingIdRef.current === id) return;
    const {
      anchor,
      offset
    } = (0, _utils.getAnchorAndOffset)(map, location, 6);
    parkingTooltip.current = new _maplibreGl.Popup({
      anchor,
      offset,
      className: 'map-tooltip',
      closeButton: false
    }).setHTML(t(`commons.parking.racks${locked ? '_locked' : supervised ? '_supervised' : sheltered ? '_sheltered' : ''}`, {
      count: capacity,
      capacity
    })).setLngLat(location).addTo(map);
  }
  function clearTooltip() {
    parkingTooltip.current?.remove();
  }
  function clear() {
    parkingLotsRef.current = [];
    Object.values(markers.current).forEach(({
      marker
    }) => {
      marker.remove();
    });
    markers.current = {};
    selectedParkingIdRef.current = null;
    selectParking(null);
    clearTooltip();
    clearGeoJSONSource();
  }
  return {
    initialized: initialized.current,
    selectedParking,
    init,
    update,
    unselect,
    clear
  };
}